import React from "react";

const BarcodeCell = ({ barcode, show }) => {
    if (!show) return null;

    return (
        <td>
            {barcode ? (
                <img
                    src={`https://curbstand.com/?wc_barcode=${barcode}`}
                    alt="Barcode"
                    style={{ width: "80px", height: "auto" }}
                />
            ) : (
                "-"
            )}
        </td>
    );
};

export default BarcodeCell;